import BiocFacade from '@baidu/bioc-jssdk';

export const BIOC_AK = 'noJI6Jm2GJLsqWVVY9izmkLHwLVbahdz';

export const initCaptcha = (cb) => {
    const captcha = BiocFacade.createCaptcha({ak: BIOC_AK});
    captcha.showPopup();
    captcha.onSuccess(token => {
        cb && cb(token.stk);
    });
};